import { helpers } from '@vuelidate/validators';

export const phoneNumberRule = helpers.withMessage(
  'Phone number is not valid',
  helpers.regex(/^\+1 \([0-9]{3}\) [0-9]{3}-[0-9]{4}$/),
);
